// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Styles pour la notification dans la sidebar */
.pending_order_notification_pendingOrderAlert__srBSm {
  margin: 10px 15px;
  /* padding: 10px; */
  background-color: #fff8e1;
  border-left: 4px solid #ffc107;
  border-radius: 4px;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.2s;
  text-align: left;
}

.pending_order_notification_pendingOrderAlert__srBSm:hover {
  background-color: #fff3cd;
}

.pending_order_notification_pendingOrderIcon__8FDT9 {
  color: #ffc107;
  font-size: 24px;
  margin-right: 15px;
}

.pending_order_notification_pendingOrderInfo__8ncYC {
  flex: 1 1;
}

.pending_order_notification_pendingOrderInfo__8ncYC h4 {
  margin: 0 0 5px 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.pending_order_notification_pendingOrderInfo__8ncYC p {
  margin: 2px 0;
  font-size: 13px;
  color: #666;
}

/* Styles pour l'icône animée avec flèche tournante */
.pending_order_notification_notificationIcon__p\\+uqD {
  position: relative;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 100;
}

.pending_order_notification_logoImage__\\+\\+QkT {
  width: 40px;
  height: 40px;
  position: relative;
  z-index: 2;
  border-radius: 50%;
}

.pending_order_notification_spinningCircle__Fr29m {
  position: absolute;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: pending_order_notification_spin__-A1Rb 1.5s linear infinite;
  z-index: 1;
}

.pending_order_notification_circleIcon__iMVTv {
  width: 40px;
  height: 40px;
  object-fit: contain;
}

@keyframes pending_order_notification_spin__-A1Rb {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.pending_order_notification_iconBadge__ipVon {
  position: absolute;
  top: -5px;
  right: -5px;
  background-color: #ff5252;
  color: white;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
  z-index: 3;
}

/* Styles pour le modal */
.pending_order_notification_orderModal__G2mnz {
  width: 650px;
  max-width: 95%;
  margin: 0 auto;
}

.pending_order_notification_modalContent__TbQnX {
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  border: none;
}

/* Assurez-vous que le backdrop couvre tout l'écran */
.modal-backdrop {
  opacity: 0.5;
}

.modal-dialog {
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.modal {
  display: flex !important;
  align-items: center;
  justify-content: center;
}

.pending_order_notification_modalHeader__4CSxk {
  background-color: var(--global-main-color);
  color: #fff;
  padding: 15px 20px;
  border-bottom: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

.pending_order_notification_modalIcon__kfefF {
  margin-right: 10px;
}

.pending_order_notification_closeButton__R6mn0 {
  background: none;
  border: none;
  color: #fff;
  font-size: 18px;
  cursor: pointer;
  transition: transform 0.2s;
}

.pending_order_notification_closeButton__R6mn0:hover {
  transform: scale(1.1);
}

.pending_order_notification_modalBody__Y9iMw {
  padding: 20px;
  max-height: 70vh;
  overflow-y: auto;
}

.pending_order_notification_orderItem__cjCUt {
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.05);
  margin-bottom: 20px;
  overflow: hidden;
  transition: transform 0.2s, box-shadow 0.2s;
  border: 1px solid #f0f0f0;
}

.pending_order_notification_orderItem__cjCUt:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.pending_order_notification_orderItem__cjCUt:last-child {
  margin-bottom: 0;
}

.pending_order_notification_orderHeader__C-Nf9 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  background-color: #f9f9f9;
  border-bottom: 1px solid #eee;
}

.pending_order_notification_orderHeader__C-Nf9 h5 {
  margin: 0;
  color: #333;
  font-weight: 600;
  font-size: 16px;
}

.pending_order_notification_orderStatus__yuBEN {
  display: flex;
  align-items: center;
  color: #ffc107;
  font-weight: 500;
  font-size: 14px;
}

.pending_order_notification_statusIcon__Bt42c {
  margin-right: 5px;
}

.pending_order_notification_orderDetails__oqKQ- {
  margin-bottom: 15px;
}

.pending_order_notification_orderInfoGrid__CoWYN {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
}

.pending_order_notification_infoItem__OMvlk {
  display: flex;
  align-items: flex-start;
}

.pending_order_notification_infoIcon__JzpWO {
  color: var(--global-main-color);
  margin-right: 12px;
  margin-top: 3px;
  width: 16px;
}

.pending_order_notification_infoLabel__6joPs {
  font-weight: 600;
  color: var(--global-main-color);
  font-size: 14px;
  margin-right: 5px;
}

.pending_order_notification_infoValue__gQuhI {
  font-size: 14px;
  color: #333;
  font-weight: 500;
  word-break: break-word;
}

.pending_order_notification_viewOrderPrompt__vug9b {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--global-main-color);
  font-size: 14px;
  font-weight: 500;
  margin-top: 15px;
  padding-top: 10px;
  border-top: 1px dashed #eee;
}

.pending_order_notification_viewIcon__TTGpo {
  margin-right: 8px;
}

@keyframes pending_order_notification_fadeIn__an1IX {
  from { opacity: 0; transform: translateY(-20px); }
  to { opacity: 1; transform: translateY(0); }
}

/* Styles pour le loader de commande en cours avec moto */
.pending_order_notification_loaderContainer__k-UZF {
  text-align: center;
  padding: 20px 0;
  margin-bottom: 20px;
  border-bottom: 1px dashed #eee;
}

.pending_order_notification_loaderRoad__0ATaL {
  position: relative;
  width: 80%;
  height: 30px;
  margin: 0 auto 15px;
  background-color: #f5f5f5;
  border-radius: 4px;
  overflow: hidden;
}

.pending_order_notification_roadLine__iVF9G {
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 2px;
  background: repeating-linear-gradient(
    to right,
    #ddd,
    #ddd 10px,
    transparent 10px,
    transparent 20px
  );
}

.pending_order_notification_loaderMotorcycle__hZPWe {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  color: var(--global-main-color);
  font-size: 24px;
  animation: pending_order_notification_moveMotorcycle__e3ovN 3s infinite linear;
}

.pending_order_notification_loaderText__XYADe {
  color: var(--global-main-color);
  font-weight: 500;
  margin: 10px 0 0;
  font-size: 14px;
}

@keyframes pending_order_notification_moveMotorcycle__e3ovN {
  0% {
    left: -10%;
  }
  100% {
    left: 110%;
  }
}

/* Ajout d'un effet de rebond pour la moto */
@keyframes pending_order_notification_bounce__8PK9P {
  0%, 100% {
    transform: translateY(-50%);
  }
  50% {
    transform: translateY(-60%);
  }
}

.pending_order_notification_loaderMotorcycle__hZPWe {
  animation:
    pending_order_notification_moveMotorcycle__e3ovN 3s infinite linear,
    pending_order_notification_bounce__8PK9P 0.3s infinite alternate;
}

/* Ajout d'un style pour la référence de commande */
.pending_order_notification_orderReference__wd-Ex {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

/* Styles améliorés pour le modal */
.pending_order_notification_orderModal__G2mnz {
  width: 650px;
  max-width: 95%;
  margin: 0 auto;
}

.pending_order_notification_modalContent__TbQnX {
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  border: none;
}

.pending_order_notification_modalHeader__4CSxk {
  background-color: var(--global-main-color);
  color: #fff;
  padding: 15px 20px;
  border-bottom: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

.pending_order_notification_modalTitleContainer__8BniA {
  display: flex;
  align-items: center;
  gap: 15px;
}

.pending_order_notification_modalTitleText__tqVU8 {
  font-size: 18px;
  font-weight: 600;
}

.pending_order_notification_closeButton__R6mn0 {
  background: none;
  border: none;
  color: #fff;
  font-size: 18px;
  cursor: pointer;
  transition: transform 0.2s;
}

.pending_order_notification_closeButton__R6mn0:hover {
  transform: scale(1.1);
}

.pending_order_notification_modalBody__Y9iMw {
  padding: 20px;
  max-height: 70vh;
  overflow-y: auto;
}

.pending_order_notification_orderItem__cjCUt {
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.05);
  margin-bottom: 20px;
  overflow: hidden;
  transition: transform 0.2s, box-shadow 0.2s;
  border: 1px solid #f0f0f0;
}

.pending_order_notification_orderItem__cjCUt:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.pending_order_notification_orderHeader__C-Nf9 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  background-color: #f9f9f9;
  border-bottom: 1px solid #eee;
}

.pending_order_notification_supplierInfo__29e0h {
  display: flex;
  align-items: center;
  gap: 10px;
}

.pending_order_notification_storeIcon__PRqne {
  color: var(--global-main-color);
  font-size: 16px;
}

.pending_order_notification_supplierName__PAFWW {
  font-weight: 600;
  color: var(--global-main-color);
  font-size: 15px;
}

.pending_order_notification_orderRef__iZF5\\+ {
  font-weight: 600;
  color: #666;
  font-size: 14px;
}

.pending_order_notification_orderContent__k9WMZ {
  padding: 20px;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.pending_order_notification_orderInfoColumn__M6h0n {
  flex: 1 1;
  min-width: 250px;
}

.pending_order_notification_infoItem__OMvlk {
  display: flex;
  align-items: flex-start;
  margin-bottom: 15px;
}

.pending_order_notification_infoIcon__JzpWO {
  color: var(--global-main-color);
  margin-right: 12px;
  margin-top: 3px;
  width: 16px;
}

.pending_order_notification_infoContent__ULQJ2 {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 5px;
}

.pending_order_notification_infoLabel__6joPs {
  font-weight: 600;
  color: var(--global-main-color);
  font-size: 14px;
  margin-right: 5px;
}

.pending_order_notification_infoValue__gQuhI {
  font-size: 14px;
  color: #333;
  font-weight: 500;
  word-break: break-word;
}

.pending_order_notification_orderFooter__BSwVB {
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #eee;
  background-color: #f9f9f9;
}

.pending_order_notification_viewDetailsButton__0XnmR {
  background-color: var(--global-main-color);
  color: white;
  border: none;
  border-radius: 6px;
  padding: 8px 15px;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.pending_order_notification_viewDetailsButton__0XnmR:hover {
  background-color: var(--global-main-color-pressed);
}

.pending_order_notification_viewIcon__TTGpo {
  font-size: 14px;
}

.pending_order_notification_deliveryStatus__p7g5n {
  display: flex;
  align-items: center;
  gap: 10px;
  color: var(--global-main-color);
  font-weight: 500;
  font-size: 14px;
}

/* Responsive design */
@media (max-width: 576px) {
  .pending_order_notification_orderContent__k9WMZ {
    flex-direction: column;
    gap: 10px;
  }

  .pending_order_notification_orderInfoColumn__M6h0n {
    min-width: 100%;
  }

  .pending_order_notification_orderFooter__BSwVB {
    flex-direction: column;
    gap: 15px;
  }

  .pending_order_notification_viewDetailsButton__0XnmR {
    width: 100%;
    justify-content: center;
  }

  .pending_order_notification_deliveryStatus__p7g5n {
    width: 100%;
    justify-content: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/shop/components/pending_order/pending_order_notification.module.css"],"names":[],"mappings":"AAAA,gDAAgD;AAChD;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA,qDAAqD;AACrD;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sEAAoC;EACpC,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,UAAU;AACZ;;AAEA,yBAAyB;AACzB;EACE,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,YAAY;AACd;;AAEA,qDAAqD;AACrD;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;EAC1C,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,OAAO,UAAU,EAAE,4BAA4B,EAAE;EACjD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA,yDAAyD;AACzD;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,WAAW;EACX,WAAW;EACX;;;;;;GAMC;AACH;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,2BAA2B;EAC3B,+BAA+B;EAC/B,eAAe;EACf,8EAA4C;AAC9C;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,4CAA4C;AAC5C;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;;oEAEgC;AAClC;;AAEA,mDAAmD;AACnD;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA,mCAAmC;AACnC;EACE,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,YAAY;AACd;;AAEA;EACE,0CAA0C;EAC1C,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;EAC3C,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF","sourcesContent":["/* Styles pour la notification dans la sidebar */\n.pendingOrderAlert {\n  margin: 10px 15px;\n  /* padding: 10px; */\n  background-color: #fff8e1;\n  border-left: 4px solid #ffc107;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  text-align: left;\n}\n\n.pendingOrderAlert:hover {\n  background-color: #fff3cd;\n}\n\n.pendingOrderIcon {\n  color: #ffc107;\n  font-size: 24px;\n  margin-right: 15px;\n}\n\n.pendingOrderInfo {\n  flex: 1;\n}\n\n.pendingOrderInfo h4 {\n  margin: 0 0 5px 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: #333;\n}\n\n.pendingOrderInfo p {\n  margin: 2px 0;\n  font-size: 13px;\n  color: #666;\n}\n\n/* Styles pour l'icône animée avec flèche tournante */\n.notificationIcon {\n  position: relative;\n  width: 50px;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  z-index: 100;\n}\n\n.logoImage {\n  width: 40px;\n  height: 40px;\n  position: relative;\n  z-index: 2;\n  border-radius: 50%;\n}\n\n.spinningCircle {\n  position: absolute;\n  width: 60px;\n  height: 60px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: spin 1.5s linear infinite;\n  z-index: 1;\n}\n\n.circleIcon {\n  width: 40px;\n  height: 40px;\n  object-fit: contain;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.iconBadge {\n  position: absolute;\n  top: -5px;\n  right: -5px;\n  background-color: #ff5252;\n  color: white;\n  border-radius: 50%;\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: bold;\n  z-index: 3;\n}\n\n/* Styles pour le modal */\n.orderModal {\n  width: 650px;\n  max-width: 95%;\n  margin: 0 auto;\n}\n\n.modalContent {\n  border-radius: 12px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n  border: none;\n}\n\n/* Assurez-vous que le backdrop couvre tout l'écran */\n:global(.modal-backdrop) {\n  opacity: 0.5;\n}\n\n:global(.modal-dialog) {\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n}\n\n:global(.modal) {\n  display: flex !important;\n  align-items: center;\n  justify-content: center;\n}\n\n.modalHeader {\n  background-color: var(--global-main-color);\n  color: #fff;\n  padding: 15px 20px;\n  border-bottom: none;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-top-left-radius: 12px;\n  border-top-right-radius: 12px;\n}\n\n.modalIcon {\n  margin-right: 10px;\n}\n\n.closeButton {\n  background: none;\n  border: none;\n  color: #fff;\n  font-size: 18px;\n  cursor: pointer;\n  transition: transform 0.2s;\n}\n\n.closeButton:hover {\n  transform: scale(1.1);\n}\n\n.modalBody {\n  padding: 20px;\n  max-height: 70vh;\n  overflow-y: auto;\n}\n\n.orderItem {\n  background-color: #fff;\n  border-radius: 12px;\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.05);\n  margin-bottom: 20px;\n  overflow: hidden;\n  transition: transform 0.2s, box-shadow 0.2s;\n  border: 1px solid #f0f0f0;\n}\n\n.orderItem:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);\n}\n\n.orderItem:last-child {\n  margin-bottom: 0;\n}\n\n.orderHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px 20px;\n  background-color: #f9f9f9;\n  border-bottom: 1px solid #eee;\n}\n\n.orderHeader h5 {\n  margin: 0;\n  color: #333;\n  font-weight: 600;\n  font-size: 16px;\n}\n\n.orderStatus {\n  display: flex;\n  align-items: center;\n  color: #ffc107;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.statusIcon {\n  margin-right: 5px;\n}\n\n.orderDetails {\n  margin-bottom: 15px;\n}\n\n.orderInfoGrid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 15px;\n}\n\n.infoItem {\n  display: flex;\n  align-items: flex-start;\n}\n\n.infoIcon {\n  color: var(--global-main-color);\n  margin-right: 12px;\n  margin-top: 3px;\n  width: 16px;\n}\n\n.infoLabel {\n  font-weight: 600;\n  color: var(--global-main-color);\n  font-size: 14px;\n  margin-right: 5px;\n}\n\n.infoValue {\n  font-size: 14px;\n  color: #333;\n  font-weight: 500;\n  word-break: break-word;\n}\n\n.viewOrderPrompt {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--global-main-color);\n  font-size: 14px;\n  font-weight: 500;\n  margin-top: 15px;\n  padding-top: 10px;\n  border-top: 1px dashed #eee;\n}\n\n.viewIcon {\n  margin-right: 8px;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(-20px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n/* Styles pour le loader de commande en cours avec moto */\n.loaderContainer {\n  text-align: center;\n  padding: 20px 0;\n  margin-bottom: 20px;\n  border-bottom: 1px dashed #eee;\n}\n\n.loaderRoad {\n  position: relative;\n  width: 80%;\n  height: 30px;\n  margin: 0 auto 15px;\n  background-color: #f5f5f5;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.roadLine {\n  position: absolute;\n  top: 50%;\n  left: 0;\n  width: 100%;\n  height: 2px;\n  background: repeating-linear-gradient(\n    to right,\n    #ddd,\n    #ddd 10px,\n    transparent 10px,\n    transparent 20px\n  );\n}\n\n.loaderMotorcycle {\n  position: absolute;\n  top: 50%;\n  left: 0;\n  transform: translateY(-50%);\n  color: var(--global-main-color);\n  font-size: 24px;\n  animation: moveMotorcycle 3s infinite linear;\n}\n\n.loaderText {\n  color: var(--global-main-color);\n  font-weight: 500;\n  margin: 10px 0 0;\n  font-size: 14px;\n}\n\n@keyframes moveMotorcycle {\n  0% {\n    left: -10%;\n  }\n  100% {\n    left: 110%;\n  }\n}\n\n/* Ajout d'un effet de rebond pour la moto */\n@keyframes bounce {\n  0%, 100% {\n    transform: translateY(-50%);\n  }\n  50% {\n    transform: translateY(-60%);\n  }\n}\n\n.loaderMotorcycle {\n  animation:\n    moveMotorcycle 3s infinite linear,\n    bounce 0.3s infinite alternate;\n}\n\n/* Ajout d'un style pour la référence de commande */\n.orderReference {\n  font-size: 16px;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 15px;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #eee;\n}\n\n/* Styles améliorés pour le modal */\n.orderModal {\n  width: 650px;\n  max-width: 95%;\n  margin: 0 auto;\n}\n\n.modalContent {\n  border-radius: 12px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n  border: none;\n}\n\n.modalHeader {\n  background-color: var(--global-main-color);\n  color: #fff;\n  padding: 15px 20px;\n  border-bottom: none;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-top-left-radius: 12px;\n  border-top-right-radius: 12px;\n}\n\n.modalTitleContainer {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.modalTitleText {\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.closeButton {\n  background: none;\n  border: none;\n  color: #fff;\n  font-size: 18px;\n  cursor: pointer;\n  transition: transform 0.2s;\n}\n\n.closeButton:hover {\n  transform: scale(1.1);\n}\n\n.modalBody {\n  padding: 20px;\n  max-height: 70vh;\n  overflow-y: auto;\n}\n\n.orderItem {\n  background-color: #fff;\n  border-radius: 12px;\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.05);\n  margin-bottom: 20px;\n  overflow: hidden;\n  transition: transform 0.2s, box-shadow 0.2s;\n  border: 1px solid #f0f0f0;\n}\n\n.orderItem:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);\n}\n\n.orderHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px 20px;\n  background-color: #f9f9f9;\n  border-bottom: 1px solid #eee;\n}\n\n.supplierInfo {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.storeIcon {\n  color: var(--global-main-color);\n  font-size: 16px;\n}\n\n.supplierName {\n  font-weight: 600;\n  color: var(--global-main-color);\n  font-size: 15px;\n}\n\n.orderRef {\n  font-weight: 600;\n  color: #666;\n  font-size: 14px;\n}\n\n.orderContent {\n  padding: 20px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n}\n\n.orderInfoColumn {\n  flex: 1;\n  min-width: 250px;\n}\n\n.infoItem {\n  display: flex;\n  align-items: flex-start;\n  margin-bottom: 15px;\n}\n\n.infoIcon {\n  color: var(--global-main-color);\n  margin-right: 12px;\n  margin-top: 3px;\n  width: 16px;\n}\n\n.infoContent {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 5px;\n}\n\n.infoLabel {\n  font-weight: 600;\n  color: var(--global-main-color);\n  font-size: 14px;\n  margin-right: 5px;\n}\n\n.infoValue {\n  font-size: 14px;\n  color: #333;\n  font-weight: 500;\n  word-break: break-word;\n}\n\n.orderFooter {\n  padding: 15px 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-top: 1px solid #eee;\n  background-color: #f9f9f9;\n}\n\n.viewDetailsButton {\n  background-color: var(--global-main-color);\n  color: white;\n  border: none;\n  border-radius: 6px;\n  padding: 8px 15px;\n  font-size: 14px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.viewDetailsButton:hover {\n  background-color: var(--global-main-color-pressed);\n}\n\n.viewIcon {\n  font-size: 14px;\n}\n\n.deliveryStatus {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: var(--global-main-color);\n  font-weight: 500;\n  font-size: 14px;\n}\n\n/* Responsive design */\n@media (max-width: 576px) {\n  .orderContent {\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .orderInfoColumn {\n    min-width: 100%;\n  }\n\n  .orderFooter {\n    flex-direction: column;\n    gap: 15px;\n  }\n\n  .viewDetailsButton {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .deliveryStatus {\n    width: 100%;\n    justify-content: center;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pendingOrderAlert": `pending_order_notification_pendingOrderAlert__srBSm`,
	"pendingOrderIcon": `pending_order_notification_pendingOrderIcon__8FDT9`,
	"pendingOrderInfo": `pending_order_notification_pendingOrderInfo__8ncYC`,
	"notificationIcon": `pending_order_notification_notificationIcon__p+uqD`,
	"logoImage": `pending_order_notification_logoImage__++QkT`,
	"spinningCircle": `pending_order_notification_spinningCircle__Fr29m`,
	"spin": `pending_order_notification_spin__-A1Rb`,
	"circleIcon": `pending_order_notification_circleIcon__iMVTv`,
	"iconBadge": `pending_order_notification_iconBadge__ipVon`,
	"orderModal": `pending_order_notification_orderModal__G2mnz`,
	"modalContent": `pending_order_notification_modalContent__TbQnX`,
	"modalHeader": `pending_order_notification_modalHeader__4CSxk`,
	"modalIcon": `pending_order_notification_modalIcon__kfefF`,
	"closeButton": `pending_order_notification_closeButton__R6mn0`,
	"modalBody": `pending_order_notification_modalBody__Y9iMw`,
	"orderItem": `pending_order_notification_orderItem__cjCUt`,
	"orderHeader": `pending_order_notification_orderHeader__C-Nf9`,
	"orderStatus": `pending_order_notification_orderStatus__yuBEN`,
	"statusIcon": `pending_order_notification_statusIcon__Bt42c`,
	"orderDetails": `pending_order_notification_orderDetails__oqKQ-`,
	"orderInfoGrid": `pending_order_notification_orderInfoGrid__CoWYN`,
	"infoItem": `pending_order_notification_infoItem__OMvlk`,
	"infoIcon": `pending_order_notification_infoIcon__JzpWO`,
	"infoLabel": `pending_order_notification_infoLabel__6joPs`,
	"infoValue": `pending_order_notification_infoValue__gQuhI`,
	"viewOrderPrompt": `pending_order_notification_viewOrderPrompt__vug9b`,
	"viewIcon": `pending_order_notification_viewIcon__TTGpo`,
	"loaderContainer": `pending_order_notification_loaderContainer__k-UZF`,
	"loaderRoad": `pending_order_notification_loaderRoad__0ATaL`,
	"roadLine": `pending_order_notification_roadLine__iVF9G`,
	"loaderMotorcycle": `pending_order_notification_loaderMotorcycle__hZPWe`,
	"moveMotorcycle": `pending_order_notification_moveMotorcycle__e3ovN`,
	"loaderText": `pending_order_notification_loaderText__XYADe`,
	"bounce": `pending_order_notification_bounce__8PK9P`,
	"orderReference": `pending_order_notification_orderReference__wd-Ex`,
	"modalTitleContainer": `pending_order_notification_modalTitleContainer__8BniA`,
	"modalTitleText": `pending_order_notification_modalTitleText__tqVU8`,
	"supplierInfo": `pending_order_notification_supplierInfo__29e0h`,
	"storeIcon": `pending_order_notification_storeIcon__PRqne`,
	"supplierName": `pending_order_notification_supplierName__PAFWW`,
	"orderRef": `pending_order_notification_orderRef__iZF5+`,
	"orderContent": `pending_order_notification_orderContent__k9WMZ`,
	"orderInfoColumn": `pending_order_notification_orderInfoColumn__M6h0n`,
	"infoContent": `pending_order_notification_infoContent__ULQJ2`,
	"orderFooter": `pending_order_notification_orderFooter__BSwVB`,
	"viewDetailsButton": `pending_order_notification_viewDetailsButton__0XnmR`,
	"deliveryStatus": `pending_order_notification_deliveryStatus__p7g5n`,
	"fadeIn": `pending_order_notification_fadeIn__an1IX`
};
export default ___CSS_LOADER_EXPORT___;
